import { FormLayout } from "@careinfo/layout";
import { AccessControl } from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { ColumnDef } from "@tanstack/react-table";
import moment from "moment";
import { ClipboardEvent, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/EndPoint";
import { getApiData } from "../../helpers/AxiosInstance";
import { createPickupRequestValidationForm } from "../../utils/validationSchemas";
import DriverForm from "../DriverForm";
import Card from "../Reusable/Card";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import Modal from "../Reusable/Modal";
import VehicleForm from "../VehicleForm";
import ChangeStatus from "./ChangeStatus";
import PickupRequestForm from "./PickupRequestForm";

const EditPickupRequest = (props: any) => {
  const [searchParams, setSearchParms] = useSearchParams({
    limit: "10",
    page: "0",
    searchQuery: "",
  });
  const [orderId, setOrderId] = useState(null);
  const [senderId, setSenderId] = useState(null);
  const [openStatusPopup, setOpenStatusPopup] = useState(false);
  const [statusData, setStatusData] = useState<any>([]);
  const [statuslist, setStatusList] = useState<any>([]);

  const {
    isLoading,
    data,
    handleAttachConsignment,
    handleToggleMarkAsDone,
    defaultValue,
    setDefaultValue,
    gridData,
    handlecheckConsignments,
    handleAddVehicle,
    isVehicleLoading,
    handleAddDriver,
    isDriverLoading,
    handleUpdate,
    openAddDriverPopup,
    openAddVehiclePopup,
    setOpenAddDriverPopup,
    setOpenAddVehiclePopup,
  } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    control,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createPickupRequestValidationForm),
    defaultValues: async () => {
      return {
        ...data,
        driver: {
          name: data?.driver?.user?.full_name,
          id: data?.driver?.id,
        },
        vehicle: {
          name: data?.vehicle?.license_number,
          id: data?.vehicle?.id,
        },
        note: data?.note,
        order_count: data?.order_count,
        priority: {
          id: data?.priority,
          name: data?.priority,
        },
      };
    },
  });

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter" && event.target.value?.length > 0) {
      setOrderId(event.target.value);
      if (!data?.is_active) {
        handlecheckConsignments(event.target.value, setError);
      }

      event.target.value = "";
    }
  };

  const defaultCargoColumns: ColumnDef<any, any>[] = [
    {
      header: "WayBill",
      accessorKey: "order.tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <div className={tw`cursor-pointer focus:outline-none`}>
            <p className={tw`whitespace-nowrap`}>{getValue() ?? "N/A"}</p>
            <p className={tw`text-xs text-red-500`}>
              {row?.original?.invoice_print_count ? "Printed" : null}
            </p>
          </div>
        );
      },
    },

    {
      header: "Date",
      accessorKey: "order.created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            {getValue() ? (
              <p className={tw`max-w-[80px]`}>
                {moment(getValue()).format("YY-MM-DD HH:mm:ss")}
              </p>
            ) : (
              "N/A"
            )}
          </>
        );
      },
    },
    {
      header: "Forwarding No.",
      accessorKey: "order.forwarding_no",
      cell: NACell,
    },
    {
      header: "Sender",
      accessorKey: "order.sender.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue()}</p>
            <p className={tw`text-[12px]`}>
              {row?.original?.sender?.primary_contact}
            </p>
          </>
        );
      },
    },
    {
      header: "Receiver",
      accessorKey: "order.receiver.full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue()}</p>
            <p className={tw`text-[12px]`}>
              {row?.original?.receiver?.primary_contact}
            </p>
          </>
        );
      },
    },
    {
      header: "Country",
      accessorKey: "order.receiver.country",
      cell: NACell,
    },
    {
      header: "Piece",
      accessorKey: "order.total_piece",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Weight",
      accessorKey: "order.charge_wt",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Created By",
      accessorKey: "order.created_by",
      cell: NACell,
    },
    {
      header: "Status",
      accessorKey: "order.delivery_status.name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p
              className={tw`uppercase px-1 text-center rounded-md`}
              style={{
                background: row?.original?.order?.delivery_status?.color,
              }}
            >
              {getValue()}
            </p>
            <p className={tw`text-xs text-primary`}>
              {row?.original?.rider?.name}
            </p>
          </>
        );
      },
    },
    {
      header: "Hub",
      accessorKey: "order.hub.name",
      cell: NACell,
    },
    {
      header: "P. Type",
      accessorKey: "order.reference_type.name",
      cell: NACell,
    },
  ];

  const handleOrderDetailNavigate = (row: any) => {
    console.log(row);
  };
  const preventCopyPaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    toast.error("Copy and paste is not allowed here");
  };

  const handleSearch = (value) => {
    searchParams.set("searchQuery", value);

    setSearchParms(searchParams);
  };
  useEffect(() => {
    if (Array.isArray(gridData?.results)) {
      setStatusData([...gridData?.results]);
    }
  }, [gridData]);

  useEffect(() => {
    {
      statusData?.map((x: any) => {
        if (x?.name === "Intermediate") {
          setStatusList(x?.status_id);
        }
      });
    }
  }, [statusData]);

  const handleAutoFill = async (id: any) => {
    const url = `${APIS.MERCHANT}${id}/`;
    try {
      const res = await getApiData(url);
      if (res?.status === 200) {
        setValue("sender_primary_contact", res?.data?.user_info?.mobile_number);
        setValue("sender_address", res?.data?.default_sender?.address);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (senderId) {
      setValue("merchant", senderId);
      handleAutoFill(senderId);
    }
  }, [senderId]);

  return (
    <>
      <AccessControl
        children={
          <FormLayout
            handleSubmit={handleSubmit}
            handleFormSubmit={handleUpdate}
            setError={setError}
            buttonLabel={"Submit"}
            isLoading={isLoading}
            disabled={!data?.is_active}
          >
            <PickupRequestForm
              register={register}
              errors={errors}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              watch={watch}
              control={control}
              setOpenAddDriverPopup={setOpenAddDriverPopup}
              setOpenAddVehiclePopup={setOpenAddVehiclePopup}
              setSenderId={setSenderId}
            />
          </FormLayout>
        }
        allowedPermissions={["can_editupdate_pickup_request"]}
      />
      {data?.is_active ? null : (
        <Card title="Barcode Scanner">
          <div className={tw`grid grid-cols-1`}>
            <div>
              <input
                type="text"
                className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                onPaste={preventCopyPaste}
                onKeyDown={handleKeyDown}
              />
            </div>
          </div>
        </Card>
      )}

      <DataTable
        url={APIS.PICKUPREQUEST_ITEMS}
        queryKey={"pickup-request-items"}
        columns={defaultCargoColumns}
        params={{ pickup_request: data?.id }}
        tableName={"pickup-request-items-table"}
        handleEditNavigate={handleOrderDetailNavigate}
        actionMenu={
          <div className={tw`w-full text-right`}>
            {data?.is_active ? (
              <button
                className={tw`p-1 px-5 rounded-sm border border-primary mr-2`}
                onClick={handleToggleMarkAsDone}
              >
                Mark As Done
              </button>
            ) : (
              ""
            )}
          </div>
        }
      />
      <Modal
        isOpen={openAddVehiclePopup}
        setIsOpen={setOpenAddVehiclePopup}
        title={"Add Vehicle"}
        children={
          <>
            <VehicleForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              handleAddVehicle={handleAddVehicle}
              isVehicleLoading={isVehicleLoading}
            />
          </>
        }
      />
      <Modal
        isOpen={openAddDriverPopup}
        setIsOpen={setOpenAddDriverPopup}
        title={"Add Driver"}
        children={
          <>
            <DriverForm
              register={register}
              errors={errors}
              handleSubmit={handleSubmit}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              handleAddDriver={handleAddDriver}
              isDriverLoading={isDriverLoading}
            />
          </>
        }
      />
      <Modal
        isOpen={openStatusPopup}
        setIsOpen={setOpenStatusPopup}
        title={"Change Status To"}
        children={
          <>
            <ChangeStatus
              handleAttachConsignment={handleAttachConsignment}
              openStatusPopup={openStatusPopup}
              setOpenStatusPopup={setOpenStatusPopup}
              orderId={orderId}
              defaultValue={defaultValue}
              setDefaultValue={setDefaultValue}
              statuslist={statuslist}
            />
          </>
        }
      />
    </>
  );
};

export default EditPickupRequest;

